import axios from "axios";
import Config from "../../config/";
import moment from "moment";
const API_KEY = Config.apikey;
const ROOT_URL = Config.rooturl;

export function cekAuth() {
  return {
    headers: { Authorization: API_KEY + localStorage.getItem("token") }
  };
}

function pushloggingx(requests, description) {
  const url = `${ROOT_URL}logactivity/logactivity/`;
  let ippublic = "-";

  const fdata = new FormData();
  fdata.append("user_id", localStorage.getItem("id"));
  fdata.append("name", localStorage.getItem("name"));
  fdata.append("email", localStorage.getItem("email"));
  fdata.append("issuperuser", localStorage.getItem("is_superuser"));
  fdata.append("ipaddress", localStorage.getItem("ipaddress"));
  fdata.append("location", localStorage.getItem("location"));
  fdata.append("date_created", moment().format("YYYY-MM-DD HH:mm:ss"));
  fdata.append("os", "");
  fdata.append("activity", requests);
  fdata.append("description", description);

  const request = axios.post(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  return request;
}

export function fetchUserAll() {
  let url = `${ROOT_URL}api/profile/?limit=2000`;

  const request = axios.get(url, cekAuth());
  return request;
}

export function fetchCompanyAll() {
  let url = `${ROOT_URL}company/company/?limit=1000`;
  // if (localStorage.getItem("email") != "admin@sibernetik.co.id") {
  //   url = `${ROOT_URL}company/company/?search=${localStorage.getItem(
  //     "company_code"
  //   )}`;
  // }
  const request = axios.get(url, cekAuth());
  return request;
}

export function pushCompany(x) {
  const url = `${ROOT_URL}company/company/`;

  const fdata = new FormData();
  fdata.append("company_name", x.company_name);
  fdata.append("company_email", x.company_email);
  fdata.append("company_limit", x.company_limit);
  fdata.append("company_code", x.company_code);
  fdata.append("company_telp", x.company_telp);
  fdata.append("company_address", x.company_address);
  fdata.append("company_img", "-");

  const request = axios.post(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  pushloggingx("post " + url, "Menambahkan data user group");
  return request;
}

export function updateCompany(x) {
  const url = `${ROOT_URL}company/company/${x.id}/`;

  const fdata = new FormData();
  fdata.append("company_name", x.company_name);
  fdata.append("company_email", x.company_email);
  fdata.append("company_limit", x.company_limit);
  fdata.append("company_code", x.company_code);
  fdata.append("company_telp", x.company_telp);
  fdata.append("company_address", x.company_address);
  fdata.append("company_img", "-");

  const request = axios.put(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  pushloggingx("update " + url, "Mengedit data user group");
  return request;
}

export function deleteCompany(id) {
  const url = `${ROOT_URL}company/company/${id}/`;

  const request = axios.delete(url, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  pushloggingx("delete " + url, "Menghapus data user group");
  return request;
}

export function deleteUser(id) {
  const url = `${ROOT_URL}api/profile/${id}/`;

  const request = axios.delete(url, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  pushloggingx("delete " + url, "Menghapus data user");
  return request;
}

export function proccessUpload(fileupload) {
  const url = `${ROOT_URL}company/uploadphotocompany/`;

  const fdata = new FormData();
  fdata.append("fileupload", fileupload);

  const request = axios.post(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });

  return request;
}
